import React, { useState, useEffect } from "react";
import { Table, Button, Dropdown } from "react-bootstrap";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PayInPdf from "../pages/PayInPdf";
import PayoutPdf from "../pages/PayoutPdf";
import PurchaseReceipt from "../pages/PurchaseReceipt";
import "./Table.css";
import { Pagechange } from "./Buttons";
import { MdChevronRight, MdChevronLeft } from "react-icons/md";
import EstimationPdf from "../pages/EstimationPdf";
import API_DOMAIN from "../config/config";
import { formatDate } from "./Forms";
import Spinner from "react-bootstrap/Spinner";
import { toast } from "react-toastify";
import { FaWhatsapp } from "react-icons/fa";
import WeeklySalaryPDF from "../pages/weekly_salary_report_pdf"; // Adjust path as needed
const Tables = (props) => {
  return (
    <Table responsive="md">
      <thead>
        <tr>
          {props.headers.map((data, index) => (
            <th key={index}>{data}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {props.body.length > 0 ? (
          props.body.map((rowData, rowIndex) => (
            <tr key={rowIndex}>
              {rowData.values.map((rowValue, colIndex) => (
                <td key={colIndex}>{rowValue}</td>
              ))}
            </tr>
          ))
        ) : (
          <tr className="text-center mx-auto">
            <td colSpan={props.headers.length}>No Record Found</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};
const ProductTable = (props) => {
  const navigate = useNavigate();
  const handlesalesreturnprintClick = (rowData) => {
    navigate("/console/sales/return", {
      state: { type: "pdfview", rowData: rowData },
    });
  };
  return (
    <Table responsive="md">
      <thead>
        <tr>
          {props.headers.map((data) => (
            <th key={data}>{data}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {props.body != null ? (
          props.body.map((rowData) => (
            <tr key={rowData.id || rowData.receipt_no}>
              {rowData.values.map((rowValue, index) => (
                <td key={index}>{rowValue}</td>
              ))}
              <td className="">
                <Dropdown>
                  <Dropdown.Toggle>
                    <Button className="action">
                      <BiDotsVerticalRounded />
                    </Button>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => handlesalesreturnprintClick(rowData)}
                    >
                      PDF
                    </Dropdown.Item>
                    <Dropdown.Item>View</Dropdown.Item>
                    <Dropdown.Item>Edit</Dropdown.Item>
                    <Dropdown.Item>Delete</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))
        ) : (
          <tr className="text-center mx-auto">
            <td colSpan={props.headers.length}>No Record Found</td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};
const TableUI = ({
  headers,
  body,
  style,
  type,
  rowData,
  planViewAction,
  onClick,
  onDelete,
  handleEditClick,
  pageview,
  onWhatsAppSend,
}) => {
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalItems = body ? body.length : 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [loading, setLoading] = useState(false);
  // Slice the data to get the current page's items
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentItems = body ? body.slice(startIndex, endIndex) : [];
  // Function to check if the next page has data
  const hasDataOnPage = (page) => {
    const pageStartIndex = (page - 1) * itemsPerPage;
    const pageEndIndex = pageStartIndex + itemsPerPage;
    const itemsOnPage = body ? body.slice(pageStartIndex, pageEndIndex) : [];
    return itemsOnPage.length > 0;
  };
  // Handle Next Page
  const nextPage = () => {
    const nextPageNumber = currentPage + 1;
    if (nextPageNumber <= totalPages && hasDataOnPage(nextPageNumber)) {
      setCurrentPage(nextPageNumber);
    }
  };
  // Handle Previous Page
  const prevPage = () => {
    const prevPageNumber = currentPage - 1;
    if (prevPageNumber >= 1 && hasDataOnPage(prevPageNumber)) {
      setCurrentPage(prevPageNumber);
    }
  };
  // Ensure currentPage stays within valid bounds
  useEffect(() => {
    if (currentPage > totalPages && totalPages > 0) {
      setCurrentPage(totalPages);
    } else if (currentPage < 1 && totalPages > 0) {
      setCurrentPage(1);
    }
  }, [currentPage, totalPages, body]);
  const navigate = useNavigate();
  const handleUserEdit = (rowData) => {
    handleEditClick(rowData);
  };
  const handleUserDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/user.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          delete_user_id: id,
        }),
      });
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handleCompanyEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handlePartyPurchaseEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handlePartyPurchaseDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/purchase_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          delete_party_id: id,
          company_id: companyId,
        }),
      });
      const responseData = await response.json();
      if (responseData.status === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handlePartyPurchaseTransactionEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handlePartySalesEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handlePartySalesDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          delete_party_id: id,
          company_id: companyId,
        }),
      });
      const responseData = await response.json();
      if (responseData.status === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handleItemProdutEditClick = (rowData) => {
    navigate("/console/item/create", {
      state: { type: "edit", rowData: rowData },
    });
  };
  const handleItemProductDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/products.php?id=${companyId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            product_id: id,
          }),
        }
      );
      const responseData = await response.json();
      if (responseData.status === 200) {
        window.location.reload();
        onDelete();
      }
    } catch (error) {}
  };
  const handleItemProdutTransactionEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handleItemCategoryEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handleItemCategoryDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/category.php?id=${companyId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            category_id: id,
          }),
        }
      );
      const responseData = await response.json();
      if (responseData.status === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handlePaymentMethodDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/paymentmethod.php?id=${companyId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            payment_method_id: id,
          }),
        }
      );
      const responseData = await response.json();
      if (responseData.status === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handleItemUnitEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handleItemUnitDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/unit.php?id=${companyId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          unit_id: id,
        }),
      });
      const responseData = await response.json();
      if (responseData.status === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handleItemUnitTransactionEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handlePurchaseBillEditClick = (rowData) => {
    navigate("/console/purchase/bill/create", {
      state: { type: "edit", rowData: rowData },
    });
  };
  const handlePurchaseBillDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/purchase_bill.php?id=${companyId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            purchase_id: id,
          }),
        }
      );
      const responseData = await response.json();
      if (responseData.status === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handlePurchasePayoutEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handlePurchasePayoutDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/payout.php?id=${companyId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          payout_id: id,
        }),
      });
      const responseData = await response.json();
      if (responseData.status === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handlePurchaseReturnEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handleOnlineBillsEditClick = (rowData) => {
    navigate("/console/online/onlinebills/create", {
      state: { type: "edit", rowData: rowData },
    });
  };
  const handleOnlineBillsPrintClick = (rowData) => {
    handleEditClick(rowData);
    navigate("/console/online/bills", {
      state: { type: "print", rowData: rowData },
    });
  };
  const handleSalesInvoiceEditClick = (rowData) => {
    navigate("/console/sales/invoice/create", {
      state: { type: "edit", rowData: rowData },
    });
  };
  const handleSalesInvoiceDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/salesinvoice.php?id=${companyId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            invoice_id: id,
          }),
        }
      );
      const responseData = await response.json();
      if (responseData.status === 200) {
        window.location.reload();
      } else {
      }
    } catch (error) {}
  };
  const handleSalesInvoicePrintClick = (rowData) => {
    handleEditClick(rowData);
    navigate("/console/sales/invoice", {
      state: { type: "print", rowData: rowData },
    });
  };
  const handleSalesPayinEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handleSalesPayinDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/payin.php?id=${companyId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          payin_id: id,
        }),
      });
      const responseData = await response.json();
      if (responseData.status === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handleSalesReturnEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handleExpancesCategoryEdit = (rowData) => {
    handleEditClick(rowData);
  };
  const handleExpancesCategoryTransactionEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handleExpancesCategoryDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/expensecategory.php?id=${companyId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            delete_category_id: id,
          }),
        }
      );
      const responseData = await response.json();
      if (responseData.status === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handleExpancesItemEdit = (rowData) => {
    handleEditClick(rowData);
  };
  const handleItemTransactionEditClick = (rowData) => {
    handleEditClick(rowData);
  };
  const handleExpancesItemDeleteClick = async (id, onDelete) => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/expenseitem.php?id=${companyId}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            expenses_item_id: id,
          }),
        }
      );
      const responseData = await response.json();
      if (responseData.status === 200) {
        onDelete();
        window.location.reload();
      }
    } catch (error) {}
  };
  const handleCompanyDeleteClick = async (id) => {
    try {
      const response = await fetch(
        "https://client.barbikan.in/orchids/api/src/plan.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            delete_plan_id: id,
          }),
        }
      );
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        navigate("/console/plan");
        window.location.reload();
      } else {
      }
    } catch (error) {}
  };
  const handleRowClick = (rowData) => {
    onClick(rowData);
  };
  const handleAdvanceDetailsClick = (rowData) => {
    navigate("/console/staff/create", {
      state: { type: "view", rowData: rowData },
    });
  };
  const handleStaffEditClick = (rowData) => {
    navigate("/console/staff/create", {
      state: { type: "edit", rowData: rowData },
    });
  };
  const handleStaffDeleteClick = async (id) => {
    try {
      const response = await fetch(`${API_DOMAIN}/staff.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          delete_staff_id: id, // Send the correct parameter for deletion
          action: "deleteStaff",
        }),
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const responseData = await response.json();
      if (
        responseData?.head?.code === 200 &&
        responseData.head.msg === "Staff Deleted Successfully"
      ) {
        toast.success(responseData.head.msg || "Staff deleted successfully!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
        // Reload or navigate after success
        setTimeout(() => {
          navigate("/console/staff");
          window.location.reload();
        }, 1000);
      } else {
        toast.error(responseData.head.msg || "Failed to delete staff!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        });
      }
    } catch (error) {
      toast.error(
        "Unexpected error occurred. Please check your connection or try again.",
        {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "colored",
        }
      );
    }
  };
  const handleAttendanceEditClick = (rowData) => {
    console.log("rowddata vvalues", rowData);
    navigate("/console/attendance/create", {
      state: { type: "edit", rowData: rowData },
    });
  };
  const handleAttendanceDeleteClick = async (id) => {
    try {
      const response = await fetch(`${API_DOMAIN}/attendance.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attendance_id: id, // Ensure this matches backend
          action: "deleteAttendance",
        }),
      });
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        toast.success(responseData.head.msg || "Deleted successfully");
        setTimeout(() => {
          navigate("/console/attendance");
          window.location.reload();
        }, 1000);
      } else {
        throw new Error(responseData.head.msg || "Failed to delete attendance");
      }
    } catch (error) {
      toast.error(error.message || "Unexpected error occurred.");
    }
  };
  const handleWeeklySalaryEditClick = (rowData) => {
    navigate("/console/weeklysalary/create", {
      state: { type: "edit", rowData: rowData },
    });
  };
  const handleWeeklySalaryDeleteClick = async (id) => {
    try {
      setLoading(true);
      const response = await fetch(`${API_DOMAIN}/weekly_salary.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          weekly_salary_id: id,
          action: "deleteWeeklySalary",
        }),
      });
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const responseData = await response.json();
      if (responseData.head.code === 200) {
        toast.success(responseData.head.msg || "Deleted successfully");
        if (typeof onDelete === "function") {
          onDelete();
        }
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        throw new Error(
          responseData.head.msg || "Failed to delete weekly salary"
        );
      }
    } catch (error) {
      toast.error(error.message || "Unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {pageview === "yes" && pageview !== undefined ? (
        <div className="text-end">
          <span className="mx-1">
            Page {currentPage} of {totalPages}
          </span>
          <span className="mx-1">
            <Pagechange
              label={<MdChevronLeft />}
              onClick={prevPage}
              disabled={currentPage === 1 || totalItems === 0}
            />
          </span>
          <span className="mx-1">
            <Pagechange
              label={<MdChevronRight />}
              onClick={nextPage}
              disabled={currentPage === totalPages || totalItems === 0}
            />
          </span>
        </div>
      ) : null}
      <Table responsive="md" style={style}>
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th key={index}>{header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentItems.length === 0 ? (
            <tr>
              <td colSpan={headers.length} className="text-center py-3">
                No record found
              </td>
            </tr>
          ) : (
            currentItems.map((rowData, rowIndex) => (
              <tr key={rowIndex}>
                {type === "USER" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.name}</td>
                    <td>{rowData.phone_number}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleUserEdit(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handleUserDeleteClick(rowData.user_id, onDelete)
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "company" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.company_name}</td>
                    <td>{rowData.gst_no}</td>
                    <td>{rowData.mobile_number}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleCompanyEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "partypurches" && (
                  <>
                    <td onClick={() => handleRowClick(rowData)}>
                      {rowData.party_name}
                    </td>
                    {/* <td onClick={() => handleRowClick(rowData)}>
                    {rowData.ac_type}
                  </td> */}
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              handlePartyPurchaseEditClick(rowData)
                            }
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handlePartyPurchaseDeleteClick(
                                rowData.party_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "partypurchestransactions" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{formatDate(rowData.date)}</td>
                    <td>{rowData.receipt_no}</td>
                    <td>
                      {parseFloat(rowData.amount || 0).toLocaleString("en-IN")}
                    </td>
                    <td>
                      {parseFloat(rowData.paid || 0).toLocaleString("en-IN")}
                    </td>
                    <td>{rowData.payment_method || "-"}</td>
                    <td>
                      {parseFloat(rowData.balance || 0).toLocaleString("en-IN")}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {rowData.details || "-"}
                    </td>
                    {/* WhatsApp Icon only in the LAST row */}
                    <td>
                      {rowIndex === currentItems.length - 1 &&
                        body.length > 0 && (
                          <Button
                            variant="success"
                            size="sm"
                            onClick={() => {
                              if (typeof onWhatsAppSend === "function") {
                                onWhatsAppSend(rowData);
                              }
                            }}
                            title="Send Statement via WhatsApp"
                          >
                            <FaWhatsapp size={24} color="blue" />
                          </Button>
                        )}
                    </td>
                  </>
                )}
                {type === "partysales" && (
                  <>
                    <td onClick={() => handleRowClick(rowData)}>
                      {rowData.party_name}
                    </td>
                    {/* <td onClick={() => handleRowClick(rowData)}>
                    {rowData.opening_balance}
                  </td> */}
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handlePartySalesEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handlePartySalesDeleteClick(
                                rowData.party_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "partysalestransactions" && (
                  <>
                    {" "}
                    {/* Fragment shorthand */}
                    <td>{rowIndex + 1}</td>
                    <td>{formatDate(rowData.date)}</td>
                    <td>{rowData.receipt_no}</td>
                    <td>{rowData.amount}</td>
                    <td>{rowData.paid}</td>
                    <td>{rowData.payment_method}</td>
                    <td>{rowData.balance}</td>
                    <td style={{ textAlign: "right" }}>
                      {rowData.details || "-"}
                    </td>
                    {/* <td className='text-end'>
                                    <Dropdown>
                                        <Dropdown.Toggle>
                                            <Button className='action'><BiDotsVerticalRounded /></Button>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => handlePartySalesTransactionEditClick(rowData)}>Edit</Dropdown.Item>
                                            <Dropdown.Item onClick={() => handleCompanyDeleteClick(rowData.id)}>Delete</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </td> */}
                  </>
                )}
                {type === "partysalesbalancesheet" && (
                  <>
                    <td>{formatDate(rowData.Date)}</td>
                    <td>{rowData.Particulars}</td>
                    <td>
                      {rowData.Credit
                        ? parseFloat(rowData.Credit).toLocaleString("en-IN")
                        : "0"}
                    </td>
                    <td>
                      {rowData.Debit
                        ? parseFloat(rowData.Debit).toLocaleString("en-IN")
                        : "0"}
                    </td>
                    <td>
                      {parseFloat(rowData.Balance || 0).toLocaleString("en-IN")}
                    </td>
                    {/* WhatsApp Icon only in the LAST row of the current page */}
                    <td>
                      {rowIndex === 0 &&
                        body.length > 0 && (
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => {
                              if (typeof onWhatsAppSend === "function") {
                                onWhatsAppSend(rowData); // Pass the specific row data (Credit: 30000, etc.)
                              }
                            }}
                            title="Send via WhatsApp"
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              backgroundColor: "#007bff",
                              borderColor: "#007bff",
                            }} // Force blue if theme is different
                          >
                            <FaWhatsapp size={24} color="blue" />
                          </Button>
                        )}
                    </td>
                  </>
                )}
                {type === "partypurchasetransactions" && (
                  <>
                    {" "}
                    {/* Fragment shorthand */}
                    <td>{rowIndex + 1}</td>
                    <td>{formatDate(rowData.date)}</td>
                    <td>{rowData.receipt_no}</td>
                    <td>{rowData.amount}</td>
                    <td>{rowData.paid}</td>
                    <td>{rowData.payment_method}</td>
                    <td>{rowData.balance}</td>
                    <td style={{ textAlign: "right" }}>
                      {rowData.details || "-"}
                    </td>
                    {/* <td className='text-end'>
                                    <Dropdown>
                                        <Dropdown.Toggle>
                                            <Button className='action'><BiDotsVerticalRounded /></Button>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={() => handlePartySalesTransactionEditClick(rowData)}>Edit</Dropdown.Item>
                                            <Dropdown.Item onClick={() => handleCompanyDeleteClick(rowData.id)}>Delete</Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </td> */}
                  </>
                )}
                {type === "partypurchasebalancesheet" && (
                  <>
                    <td>{formatDate(rowData.Date)}</td>
                    <td>{rowData.Particulars}</td>
                    <td>
                      {rowData.Credit
                        ? parseFloat(rowData.Credit).toLocaleString("en-IN")
                        : "0"}
                    </td>
                    <td>
                      {rowData.Debit
                        ? parseFloat(rowData.Debit).toLocaleString("en-IN")
                        : "0"}
                    </td>
                    <td>
                      {parseFloat(rowData.Balance || 0).toLocaleString("en-IN")}
                    </td>

                    {/* WhatsApp Icon only in the LAST row of the current page */}
                    <td>
                      {rowIndex === 0 &&
                        body.length > 0 && (
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => {
                              if (typeof onWhatsAppSend === "function") {
                                onWhatsAppSend(rowData); // Pass the specific row data (Credit: 30000, etc.)
                              }
                            }}
                            title="Send via WhatsApp"
                            className="d-flex align-items-center justify-content-center"
                            style={{
                              backgroundColor: "#007bff",
                              borderColor: "#007bff",
                            }} // Force blue if theme is different
                          >
                            <FaWhatsapp size={24} color="blue" />
                          </Button>
                        )}
                    </td>
                  </>
                )}
                {type === "itemsproduct" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.product_name}</td>
                    <td>{rowData.unit_rate}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleItemProdutEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handleItemProductDeleteClick(
                                rowData.product_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "itemsproducttransactions" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.type}</td>
                    <td>{rowData.date}</td>
                    <td>{rowData.receipt_no}</td>
                    <td>{rowData.amount}</td>
                  </>
                )}
                {type === "itemscategory" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.category_name}</td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleItemCategoryEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handleItemCategoryDeleteClick(
                                rowData.category_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "paymentmethods" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.payment_method_name}</td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleItemCategoryEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handlePaymentMethodDeleteClick(
                                rowData.payment_method_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "itemscategorytransactions" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.product_name}</td>
                    <td className="text-end">{rowData.current_stock}</td>
                  </>
                )}
                {type === "itemsunit" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.unit_name}</td>
                    <td className="">
                      <Dropdown className="text-end">
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleItemUnitEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handleItemUnitDeleteClick(
                                rowData.unit_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "itemsunitransactions" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>
                      1 {rowData.unit_name} = {rowData.rate}{" "}
                      {rowData.subunit_name}
                    </td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              handleItemUnitTransactionEditClick(rowData)
                            }
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleCompanyDeleteClick(rowData.id)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "purchasebill" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.bill_date}</td>
                    <td>{rowData.bill_no}</td>
                    <td>{rowData.party_details.party_name}</td>
                    <td>{rowData.total}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <PDFDownloadLink
                            document={<PurchaseReceipt data={rowData} />}
                            fileName="purchasebill.pdf"
                          >
                            {({ blob, url, loading, error }) => (
                              <a
                                className="dropdown-item"
                                role="button"
                                tabIndex="0"
                                href={url}
                              >
                                View Pdf
                              </a>
                            )}
                          </PDFDownloadLink>
                          <Dropdown.Item
                            onClick={() => handlePurchaseBillEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handlePurchaseBillDeleteClick(
                                rowData.purchase_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "purchasepayout" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{formatDate(rowData.voucher_date)}</td>
                    <td>{rowData.voucher_no}</td>
                    <td>{rowData.party_details.party_name}</td>
                    <td>{rowData.paid}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <PDFDownloadLink
                            document={<PayoutPdf data={rowData} />}
                            fileName="payout.pdf"
                          >
                            {({ blob, url, loading, error }) => (
                              <a
                                className="dropdown-item"
                                role="button"
                                tabIndex="0"
                                href={url}
                              >
                                View Pdf
                              </a>
                            )}
                          </PDFDownloadLink>
                          <Dropdown.Item
                            onClick={() =>
                              handlePurchasePayoutEditClick(rowData)
                            }
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handlePurchasePayoutDeleteClick(
                                rowData.payout_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "purchasereturn" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.date}</td>
                    <td>{rowData.receipt_no}</td>
                    <td>{rowData.name}</td>
                    <td>{rowData.total}</td>
                    <td>{rowData.received}</td>
                    <td>{rowData.due}</td>
                    <td className="">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              handlePurchaseReturnEditClick(rowData)
                            }
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleCompanyDeleteClick(rowData.id)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "onlinebills" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.enquiry_no}</td>
                    <td>
                      {rowData.tax_invoice_no ? rowData.tax_invoice_no : "-"}
                    </td>
                    <td>{rowData.customer_name}</td>
                    <td>{rowData.discount_total}</td>
                    <td>{rowData.tax_invoice_no ? "Tax Invoice" : "-"}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleOnlineBillsPrintClick(rowData)}
                          >
                            Print
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleOnlineBillsEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "salesinvoice" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{formatDate(rowData.bill_date)}</td>
                    <td>{rowData.bill_no}</td>
                    <td>{rowData.party_name}</td>
                    <td>{rowData.total}</td>
                    {/* <td>{rowData.paid}</td>
                    <td>{rowData.balance}</td> */}
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              handleSalesInvoicePrintClick(rowData)
                            }
                          >
                            Print
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleSalesInvoiceEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handleSalesInvoiceDeleteClick(rowData.invoice_id)
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "salesestimate" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.estimate_date}</td>
                    <td>{rowData.estimate_no}</td>
                    <td>{rowData.party_details.party_name}</td>
                    <td>{rowData.total}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <PDFDownloadLink
                            document={<EstimationPdf data={rowData} />}
                            fileName="SalesEstimate.pdf"
                          >
                            {({ blob, url, loading, error }) => (
                              <a
                                className="dropdown-item"
                                role="button"
                                tabIndex="0"
                                href={url}
                              >
                                View Pdf
                              </a>
                            )}
                          </PDFDownloadLink>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "salespayin" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{formatDate(rowData.receipt_date)}</td>
                    <td>{rowData.receipt_no}</td>
                    <td>{rowData.party_details.party_name}</td>
                    <td>{rowData.paid}</td>
                    <td className="">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <PDFDownloadLink
                            document={<PayInPdf data={rowData} />}
                            fileName="payin.pdf"
                          >
                            {({ blob, url, loading, error }) => (
                              <a
                                className="dropdown-item"
                                role="button"
                                tabIndex="0"
                                href={url}
                              >
                                View Pdf
                              </a>
                            )}
                          </PDFDownloadLink>
                          <Dropdown.Item
                            onClick={() => handleSalesPayinEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handleSalesPayinDeleteClick(
                                rowData.payin_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "salesreturn" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.date}</td>
                    <td>{rowData.receipt_no}</td>
                    <td>{rowData.name}</td>
                    <td>{rowData.total}</td>
                    <td>{rowData.paid}</td>
                    <td>{rowData.due}</td>
                    <td className="">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleSalesReturnEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleCompanyDeleteClick(rowData.id)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "expensescategory" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.category_name}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleExpancesCategoryEdit(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handleExpancesCategoryDeleteClick(
                                rowData.category_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "expensescategorytransactions" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.date}</td>
                    <td>{rowData.receipt_no}</td>
                    <td>{rowData.party_name}</td>
                    <td>{rowData.amount}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              handleExpancesCategoryTransactionEditClick(
                                rowData
                              )
                            }
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleCompanyDeleteClick(rowData.id)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "expensesitems" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{formatDate(rowData.bill_date)}</td>
                    <td>{rowData.category_name}</td>
                    <td>{rowData.party_name}</td>
                    <td>{rowData.total}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleExpancesItemEdit(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() =>
                              handleExpancesItemDeleteClick(
                                rowData.expenses_item_id,
                                onDelete
                              )
                            }
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "expensesitemtransactions" && (
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.date}</td>
                    <td>{rowData.receipt_no}</td>
                    <td>{rowData.party_name}</td>
                    <td>{rowData.amount}</td>
                    <td className="text-end">
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() =>
                              handleItemTransactionEditClick(rowData)
                            }
                          >
                            Edit
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleCompanyDeleteClick(rowData.id)}
                          >
                            Delete
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "staff" && ( // Rendering when type is not "USER"
                  <>
                    <td>{rowIndex + 1}</td>
                    <td>{rowData.staff_name}</td>
                    <td className="place">{rowData.role}</td>
                    <td>{rowData.advance_balance}</td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {/* <Dropdown.Item
                        onClick={() => handleCustomerViewClick(rowData)}
                      >
                        View
                      </Dropdown.Item> */}
                          <Dropdown.Item
                            onClick={() => handleAdvanceDetailsClick(rowData)}
                          >
                            Advance Details
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => handleStaffEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          {loading ? (
                            <center>
                              <Spinner animation="border" variant="dark" />{" "}
                            </center>
                          ) : (
                            <Dropdown.Item
                              onClick={() => handleStaffDeleteClick(rowData.id)}
                            >
                              Delete
                            </Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )}
                {type === "attendance" && (
                  <>
                    <td>{rowData.key}</td>
                    <td>{rowData.entry_date}</td>
                    <td>{rowData.presents}</td>
                    <td>{rowData.absents}</td>
                    <td>₹{rowData.total_wages}</td>
                    <td>
                      {/* {rowIndex === 0 ? ( */}
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => handleAttendanceEditClick(rowData)}
                          >
                            Edit
                          </Dropdown.Item>
                          {loading ? (
                            <center>
                              <Spinner animation="border" variant="dark" />
                            </center>
                          ) : (
                            <Dropdown.Item
                              onClick={() =>
                                handleAttendanceDeleteClick(
                                  rowData.attendance_id
                                )
                              }
                            >
                              Delete
                            </Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                      {/* ) : ( */}
                      {/* Using an em-dash (—) or a bold hyphen centered in a flex container */}
                      {/* <span style={{ fontWeight: "bold", color: "#333",marginLeft:"26px" }}>
                             —
                          </span> */}
                      {/* )} */}
                    </td>
                  </>
                )}
                {/* {type === "weeklysalary" && (
                  <>
                    <td>{rowData.key}</td>
                    <td>{rowData.period}</td>
                    <td>₹{rowData.totalGross.toFixed(2)}</td>
                    <td>₹{rowData.totalRecovery.toFixed(2)}</td>
                    <td>₹{rowData.finalPayable.toFixed(2)}</td>
                    <td>
                      <Dropdown>
                        <Dropdown.Toggle>
                          <Button className="action">
                            <BiDotsVerticalRounded />
                          </Button>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <PDFDownloadLink
                            document={
                              <WeeklySalaryPDF
                                data={rowData.data}
                                fromDate={rowData.from_date}
                                toDate={rowData.to_date}
                              />
                            }
                            fileName={`weekly_salary_report_${rowData.period.replace(
                              /\//g,
                              "_"
                            )}.pdf`}
                          >
                            {({ blob, url, loading, error }) => (
                              <Dropdown.Item as="a" href={url} download>
                                Download PDF
                              </Dropdown.Item>
                            )}
                          </PDFDownloadLink>
                          {body.length > 0 &&
                            rowData.weekly_salary_id ===
                              body[0].weekly_salary_id && (
                              <>
                                <Dropdown.Item
                                  onClick={() =>
                                    handleWeeklySalaryEditClick(rowData)
                                  }
                                >
                                  Edit
                                </Dropdown.Item>
                                {loading ? (
                                  <center>
                                    <Spinner
                                      animation="border"
                                      variant="dark"
                                      size="sm"
                                    />
                                  </center>
                                ) : (
                                  <Dropdown.Item
                                    onClick={() =>
                                      handleWeeklySalaryDeleteClick(
                                        rowData.weekly_salary_id
                                      )
                                    }
                                  >
                                    Delete
                                  </Dropdown.Item>
                                )}
                              </>
                            )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </td>
                  </>
                )} */}
                

{type === "weeklysalary" && (
  <>
    <td>{rowData.key}</td>
    <td>{rowData.period}</td>
    <td>{rowData.totalGross}</td> {/* Remove .toFixed() - already formatted */}
    <td>{rowData.totalRecovery}</td> {/* Remove .toFixed() - already formatted */}
    <td>{rowData.finalPayable}</td> {/* Remove .toFixed() - already formatted */}
    <td>
      <Dropdown>
        <Dropdown.Toggle>
          <Button className="action">
            <BiDotsVerticalRounded />
          </Button>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {/* Remove the PDFDownloadLink for now since we're using jsPDF */}
          <PDFDownloadLink
                            document={
                              <WeeklySalaryPDF
                                data={rowData.data}
                                fromDate={rowData.from_date}
                                toDate={rowData.to_date}
                              />
                            }
                            fileName={`weekly_salary_report_${rowData.period.replace(
                              /\//g,
                              "_"
                            )}.pdf`}
                          >
                            {({ blob, url, loading, error }) => (
                              <Dropdown.Item as="a" href={url} download>
                                Download PDF
                              </Dropdown.Item>
                            )}
                          </PDFDownloadLink>
          <Dropdown.Item
            onClick={() => handleWeeklySalaryEditClick(rowData)}
          >
            Edit
          </Dropdown.Item>
          {loading ? (
            <center>
              <Spinner
                animation="border"
                variant="dark"
                size="sm"
              />
            </center>
          ) : (
            <Dropdown.Item
              onClick={() =>
                handleWeeklySalaryDeleteClick(
                  rowData.weekly_salary_id
                )
              }
            >
              Delete
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </td>
  </>
)}
              </tr>
            ))
          )}
        </tbody>
      </Table>
      {pageview === "yes" && pageview !== undefined ? (
        <div className="text-end">
          <span className="mx-1">
            Page {currentPage} of {totalPages}
          </span>
          <span className="mx-1">
            <Pagechange
              label={<MdChevronLeft />}
              onClick={prevPage}
              disabled={currentPage === 1 || totalItems === 0}
            />
          </span>
          <span className="mx-1">
            <Pagechange
              label={<MdChevronRight />}
              onClick={nextPage}
              disabled={currentPage === totalPages || totalItems === 0}
            />
          </span>
        </div>
      ) : null}
    </>
  );
};
export { Tables, ProductTable, TableUI };
